import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const walletSchema = z.object({
  id: z.string(),
  userId: z.string(),
  updateAt: z.coerce.date(),
  balance: z.number(),
});

export class WalletDto extends createZodDto(walletSchema) {}
